<template>
  <div class="autocomplete-container mt-2 relative border border-[1px] border-gray-300">
    <div class="flex gap-2">
      <i class="fas fa-search mt-3 ml-2 searchIcon text-gray-400"></i>
      <input
        v-model="query"
        @input="fetchSuggestions"
        :placeholder="placeholder"
        class="autocomplete-input w-full p-3"
        @blur="hideSuggestions"
        @focus="showSuggestions"
      />
    </div>
    <ul v-if="showSuggestionsDropdown" class="autocomplete-suggestions absolute bg-white border border-[1px] border-gray-300 w-full overflow-y-auto list-none p-0 m-0 max-h-[200px]">
      <li v-for="(suggestion, index) in filteredSuggestions"
          :key="index"
          class="p-3 cursor-pointer hover:bg-grey-lighter"
          @click="selectSuggestion(suggestion)">
        {{ suggestion.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Type your desired location here'
    },
    country: String
  },
  data () {
    return {
      query: '',
      suggestions: [],
      showSuggestionsDropdown: false,
      errorBag: new ErrorBag()
    }
  },
  methods: {
    async fetchSuggestions () {
      if (this.query.length >= 3) {
        this.$emit('selected', this.query)
        try {
          v2Api.get(`/localities/suggest`, {
            params: {
              q: this.query,
              address_country: this.country
            }
          })
            .then(
              response => {
                this.suggestions = response.data
                this.showSuggestionsDropdown = true
              },
              errors => {
                this.errorBag.store(errors.response.data)
              })
        } catch (error) {
          console.error('Error fetching suggestions:', error)
        }
      } else {
        this.suggestions = []
        this.showSuggestionsDropdown = false
      }
    },
    selectSuggestion (suggestion) {
      this.query = suggestion.name
      this.showSuggestionsDropdown = false
      this.$emit('selected', suggestion)
    },
    hideSuggestions () {
      setTimeout(() => {
        this.showSuggestionsDropdown = false
      }, 200)
    },
    showSuggestions () {
      if (this.suggestions.length > 0) {
        this.showSuggestionsDropdown = true
      }
    }
  },
  computed: {
    filteredSuggestions () {
      return this.suggestions
    }
  }
}
</script>
